import { useState } from 'react'

const useSwipe = onSwipe => {
  const [startPoint, setStartPoint] = useState({ x: null, y: null })

  const onTouchStart = e => {
    const touch = e.touches[0]
    setStartPoint({ x: touch.clientX, y: touch.clientY })
  }

  const onTouchEnd = e => {
    if (!startPoint.x || !startPoint.y) {
      return
    }

    const endPointX = e.changedTouches[0].clientX
    const endPointY = e.changedTouches[0].clientY

    const xDiff = startPoint.x - endPointX
    const yDiff = startPoint.y - endPointY
    let direction = ''

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      direction = xDiff > 0 ? 'LEFT' : 'RIGHT'
    } else {
      direction = yDiff > 0 ? 'UP' : 'DOWN'
    }

    setStartPoint({ x: null, y: null }) // Reset startPoint
    onSwipe(direction) // Invoke the callback with the detected swipe direction
  }

  return { onTouchStart, onTouchEnd, style: { touchAction: 'manipulation' } }
}

export default useSwipe
